import React, { createContext, useContext, useState, useCallback } from "react";

interface RefreshContextType {
  triggerRefresh: () => void;
  addRefreshListener: (listener: () => void) => () => void;
}

const RefreshContext = createContext<RefreshContextType | null>(null);

export function RefreshProvider({ children }: { children: React.ReactNode }) {
  const [listeners] = useState<Set<() => void>>(new Set());

  const triggerRefresh = useCallback(() => {
    listeners.forEach((listener) => listener());
  }, [listeners]);

  const addRefreshListener = useCallback(
    (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    [listeners]
  );

  return (
    <RefreshContext.Provider value={{ triggerRefresh, addRefreshListener }}>
      {children}
    </RefreshContext.Provider>
  );
}

export function useRefresh() {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error("useRefresh must be used within a RefreshProvider");
  }
  return context;
}
